import angular from 'angular';

export const GerenciamentoDocumentosListRouting = [
    '$stateProvider',
    function ($stateProvider: angular.ui.IStateProvider): void {
        $stateProvider
            .state('meurh_gerencia_documentos', {
            url: '/gerenciamentoDocumentos?tab',
            template: require('html-loader!./index/gerenciamentodocumentos.index.html'),
            controller: 'GerenciamentoDocumentosIndexController',
            controllerAs: 'grcdocs_cntrllr',
        });
    }
];
